// removed by extract-text-webpack-plugin
module.exports = {"Segment":"Segment---1X_tn"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/settings/ChatWidget/components/HoursAndTargeting/Segment/style.styl
// module id = SCc4
// module chunks = 89